import { makeObservable, override } from 'mobx';
import BaseModel from '../../BaseModel';
import Logs from './Logs';
import makeQuery from '../../../api/makeQuery';
import { differenceInCalendarDays, format, parse } from 'date-fns';

const anniversaryRegExp = new RegExp(/^(\d{4}-11-26)$/);

const daysUntil = (now, target = []) => {
  const [ year, month, date, hour, minute ] = target;
  const count = differenceInCalendarDays(
    new Date(year, month, date, hour, minute),
    now
  );
  if (count === 1) {
    return `${count} day to`;
  }
  return  `${count} days to`;
}

const NotableEvents = {
  '2021-11-26': {
    anticipationStart: '2021-09-03',
    anticipationLabel: (date) => {
      const target = [2021, 10, 26, 14, 0];
      return `${daysUntil(date, target)} our wedding!`;
    },
    label: 'Wedding Day'
  },
  '2022-04-18': {
    anticipationStart: '2022-03-20',
    anticipationLabel: (date) => {
      const target = [2022, 3, 18, 10, 0];
      return `${daysUntil(date, target)} Carnation closing!`;
    },
    label: 'Closing Day on Carnation!'
  },
  '2022-04-20': {
    anticipationStart: '2022-04-19',
    anticipationLabel: (date) => {
      const target = [2022, 3, 20, 10, 0];
      return `${daysUntil(date, target)} Flint closing!`;
    },
    label: 'Closing Day on Flint!'
  },
  '2022-05-17': {
    anticipationStart: '2022-04-20',
    anticipationLabel: (date) => {
      const target = [2022, 4, 17, 0, 0];
      return `${daysUntil(date, target)} living in Flint!`;
    },
    label: 'Moving Day!'
  },
}

class Post extends BaseModel {
  static INITIAL_FIELDS = {
    id: '',
    createdAt: '',
    date: '',
    location: '',
    updatedAt: '',
  };
  constructor(valuesObj) {
    super(valuesObj);
    makeObservable(this, {
      merge: override
    });
    this.logs = new Logs(this, valuesObj?.logs);
  }
  merge(valuesObj) {
    super.merge(valuesObj);
    if (valuesObj) {
      if (valuesObj.logs) this.logs.replace(valuesObj.logs);
    }
  }

  async updatePost({ date, location }) {
    await makeQuery('@putPost', {
      postId: this.logs.post.id,
      date,
      location
    });
  }

  destroy() {
    this.logs.destroy();
  }

  get parsedDate() {
    return parse(this.date, 'yyyy-MM-dd', new Date());
  }

  get displayDate() {
    return format(this.parsedDate, 'EEEE, MMMM do, yyyy' );
  }

  get isAnniversary() {
    return this.date !== '2021-11-26' && anniversaryRegExp.test(this.date);
  }

  get notableLabel() {
    if (this.isAnniversary) {
      return 'Happy Anniversary!';
    }
    if (NotableEvents[this.date]) {
      return NotableEvents[this.date]?.label;
    }
    const eventDates = Object.keys(NotableEvents);
    for (const date of eventDates) {
      const event = NotableEvents[date];
      if (date > this.date && event?.anticipationStart <= this.date) {
        return event?.anticipationLabel(this.parsedDate);
      }
    }
    return '';
  }
}
export default Post;
